var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "message-box dialog-mask",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.onClickOutSide.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "dialog-box" }, [
        _c("div", { staticClass: "section dialog-header" }, [
          _c("h1", [_vm._v(_vm._s(_vm.$t("common.emphasisMarkDialog.title")))]),
        ]),
        _c("div", { staticClass: "section dialog-body" }, [
          _c("h2", [
            _vm._v(_vm._s(_vm.$t("common.emphasisMarkDialog.description"))),
          ]),
          _c("div", { staticClass: "setting-container" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.entryText,
                  expression: "entryText",
                },
              ],
              attrs: {
                type: "text",
                minlength: "1",
                maxlength: "30",
                placeholder: _vm.$t(
                  "common.emphasisMarkDialog.textPlaceholder"
                ),
              },
              domProps: { value: _vm.entryText },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.entryText = $event.target.value
                },
              },
            }),
          ]),
        ]),
        _c("div", { staticClass: "section button-area" }, [
          _c(
            "button",
            {
              staticClass: "button cancel",
              on: { click: _vm.onNegativeClick },
            },
            [_vm._v(_vm._s(_vm.negative))]
          ),
          _c(
            "button",
            {
              staticClass: "button primary",
              attrs: { disabled: !_vm.entryText },
              on: { click: _vm.onPositiveClick },
            },
            [_vm._v(" " + _vm._s(_vm.positive) + " ")]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }